import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ThememodeService } from 'src/app/shared/services';

@Component({
  selector: 'app-itopia-loader',
  templateUrl: './itopia-loader.component.html',
  styleUrls: ['./itopia-loader.component.scss']
})
export class ItopiaLoaderComponent implements OnInit, OnDestroy {

    isLight!: boolean;
    private subscriptions = new Subscription();

    constructor( private themeModeService: ThememodeService) {
        }

    ngOnInit(): void {
      this.isLight = this.themeModeService.getColorScheme() !== 'dark';

      this.subscriptions.add(
      this.themeModeService.themeChanged.subscribe(
        () => {
          this.isLight = this.themeModeService.getColorScheme() !== 'dark';
        }
      )
    );
   }

    ngOnDestroy(): void {
       this.subscriptions.unsubscribe();
    }

}
